<script lang="ts" setup>
const slots: Record<string, any> = useSlots()
</script>

<template>
  <UDropdown v-bind="$attrs" class="group/dropdown">
    <slot>
      <OptionsButton />
    </slot>
    <template v-for="(_, name) in slots" #[name]="slotData">
      <slot :name="name" v-bind="slotData" />
    </template>
  </UDropdown>
</template>
